import React from 'react';
import { Box, BoxProps, Flex, Heading, Text, Button, Link } from '@chakra-ui/react';
import { ContentCardAnimation, ContentCardAnimationList } from '@/constants/contentCardAnimations';
import { getAnimationProps } from '@/utils/getAnimationProps';

interface ContentCardProps extends BoxProps {
  title: string;
  description?: string;
  icon?: React.ReactNode;
  action?: {
    label: string;
    href: string;
    variant?: 'solid' | 'outline';
  };
  animation?: ContentCardAnimation;
  children?: React.ReactNode;
}

export const ContentCard: React.FC<ContentCardProps> = ({
  title,
  description,
  icon,
  action,
  children,
  animation,
  ...props
}) => {
  return (
    <Box
      p={{ base: '6', md: '8' }}
      bg="bg"
      borderRadius="lg"
      borderWidth="1px"
      borderColor="border"
      {...(animation ? getAnimationProps(animation, ContentCardAnimationList) : {})}
      {...props}
    >
      <Flex
        direction="column"
        align={{ base: 'center', md: 'start' }}
        textAlign={{ base: 'center', md: 'start' }}
        gap={4}
      >
        {icon && (
          <Box fontSize="3xl" color="blue.fg">
            {icon}
          </Box>
        )}
        <Heading size="lg" fontWeight="semibold">
          {title}
        </Heading>
        <Text color="fg.muted" lineHeight="relaxed">
          {description}
        </Text>
        {action && (
          <Link href={action.href} _hover={{ textDecoration: 'none' }}>
            <Button variant={action.variant || 'solid'} size="md">
              {action.label}
            </Button>
          </Link>
        )}
      </Flex>
      {children && <Box w="full">{children}</Box>}
    </Box>
  );
};
